"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../form/utils");

var _utils2 = require("../../utils");

var _dateTimeSegments = require("../date-time-segments");

var _constants = require("./constants");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

var TimePicker = function TimePicker(_ref) {
  var _ref$ariaLabels = _ref.ariaLabels,
      ariaLabels = _ref$ariaLabels === void 0 ? _constants.defaultTimeAriaLabels : _ref$ariaLabels,
      handleChange = _ref.handleChange,
      _ref$selectedTime = _ref.selectedTime,
      selectedTime = _ref$selectedTime === void 0 ? {} : _ref$selectedTime,
      showMilliseconds = _ref.showMilliseconds,
      showSeconds = _ref.showSeconds;
  return (0, _core.jsx)(_helperComponents.TimeSegmentRow, null, (0, _core.jsx)(_dateTimeSegments.DateTimeSegments, {
    ariaLabels: ariaLabels,
    labelId: (0, _utils.buildLabelId)("StencilTimePicker-".concat((0, _utils2.getUniqueId)())),
    onChange: handleChange,
    segmentValues: selectedTime,
    showDate: false,
    showMilliseconds: showMilliseconds,
    showSeconds: showSeconds,
    showSpinButtons: true,
    showTime: true
  }));
};

var _default = TimePicker;
exports.default = _default;